export enum EntraIdEvent {
    ConfigEnabled = 'EntraID.ConfigEnabled',
    ConfigDisabled = 'EntraID.ConfigDisabled',
}
